<template>
  <!-- Sin `scrollable`: el scroll va en la lista, no en la caja del modal, para que el
       pie con el desplegable y el boton de asignar sigan visibles al bajar. -->
  <modal :name="nombreModal" :adaptive="true" height="auto" width="780px">
    <div class="rev">
      <div class="modal-header rev-cabecera">
        <h4>{{ $t("tituloRevisar_" + motivo) }}</h4>
        <p>{{ $t("ayudaRevisar_" + motivo) }}</p>
      </div>

      <div class="modal-body rev-cuerpo">
        <div class="rev-barra">
          <input
            type="search"
            class="form-control rev-buscador"
            v-model="busqueda"
            :placeholder="$t('buscarMateriaPrima')"
          />

          <div class="rev-seleccion">
            <button type="button" class="rev-enlace" @click="seleccionarTodas()">
              {{ $t("seleccionarTodas") }}
            </button>
            <span class="rev-sep">·</span>
            <button type="button" class="rev-enlace" @click="seleccionarNinguna()">
              {{ $t("seleccionarNinguna") }}
            </button>
          </div>
        </div>

        <p class="rev-aviso" v-if="truncado">
          {{ $tc("revisarTruncado", tope, { n: tope, total: total }) }}
        </p>

        <p class="rev-aviso" v-if="cargado && !puedeEditar">
          {{ $t("revisarSinPermiso") }}
        </p>

        <div class="rev-lista" v-if="visibles.length">
          <label
            v-for="sub in visibles"
            :key="'s' + sub.id"
            class="rev-fila"
            :class="{ puesta: !!marcadas[sub.id] }"
          >
            <input
              type="checkbox"
              :checked="!!marcadas[sub.id]"
              :disabled="!puedeEditar"
              @change="marcar(sub.id, $event.target.checked)"
            />
            <span class="rev-nombre">{{ sub.nombre }}</span>
            <span class="rev-actual" v-if="sub.idTag">
              {{ sub.etiqueta || $t("etiquetaSinNombre") }}
              <em v-if="sub.etiquetaDeBaja">· {{ $t("deBaja") }}</em>
              <em v-else-if="sub.tipoEtiqueta === 'P'">· {{ $t("proveedor") }}</em>
              <em v-else-if="sub.tipoEtiqueta !== 'A'">· {{ $t("sinTipo") }}</em>
            </span>
            <span class="rev-actual vacia" v-else>{{ $t("sinEtiqueta") }}</span>
          </label>
        </div>

        <p class="rev-vacio" v-else-if="cargado">{{ $t("revisarNadaQueVer") }}</p>

        <p class="rev-error" v-if="error">{{ error }}</p>
      </div>

      <div class="modal-footer rev-pie">
        <div class="rev-destino">
          <label for="revDestino">{{ $t("asignarEtiqueta") }}</label>

          <!-- El mismo `el-select` filtrable que el selector de negocio de la pantalla,
               no un `select` nativo: con 48 etiquetas hace falta escribir para llegar, y
               dos desplegables distintos en la misma pantalla se notan. Cada opcion lleva
               la ruta y, a la derecha, las materias primas que ya tiene, igual que la
               columna de la tabla. -->
          <el-select
            id="revDestino"
            class="select-default rev-select"
            popper-class="rev-desplegable"
            v-model="idTagDestino"
            filterable
            clearable
            :disabled="!puedeEditar"
            :placeholder="$t('elegirEtiquetaDestino')"
            :no-match-text="$t('sinResultados')"
          >
            <el-option-group :label="$t('etiquetasDeMateriaPrima')">
              <el-option
                v-for="t in destinoVisible"
                :key="'d' + t.id"
                :value="t.id"
                :label="t.ruta"
              >
                <span class="op-ruta">{{ t.ruta }}</span>
                <span class="op-num">{{ t.materiasPrimas }}</span>
              </el-option>
            </el-option-group>

            <!-- Las ocultas van aparte y avisadas, no fuera: en el 6730 son 34 de las 48,
                 asi que dejarlas fuera vaciaba el desplegable. Pero mandar una ficha ahi
                 es cambiar un escondite por otro, y eso hay que decirlo. -->
            <el-option-group v-if="destinoOculto.length" :label="$t('destinoOculto')">
              <el-option
                v-for="t in destinoOculto"
                :key="'o' + t.id"
                :value="t.id"
                :label="t.ruta"
              >
                <span class="op-ruta oculta">{{ t.ruta }}</span>
                <span class="op-num">{{ t.materiasPrimas }}</span>
              </el-option>
            </el-option-group>
          </el-select>

          <p class="rev-nota" v-if="destinoElegidoOculto">{{ $t("avisoDestinoOculto") }}</p>
        </div>

        <div class="rev-botones">
          <!-- Quitar la etiqueta es una salida valida, pero no es una etiqueta: fuera del
               desplegable. Y no se ofrece en el listado de las que ya estan sin etiqueta,
               donde no significaria nada. -->
          <button
            type="button"
            class="rev-quitar"
            v-if="motivo !== 'sinEtiqueta'"
            :disabled="guardando || !puedeEditar || !cuantasMarcadas"
            @click="quitarEtiqueta()"
          >
            {{ $t("quitarEtiqueta") }}
          </button>
          <button type="button" class="btn btn-claro" :disabled="guardando" @click="cerrar()">
            {{ $t("cerrar") }}
          </button>
          <button
            type="button"
            class="btn btn-verde"
            :disabled="guardando || !puedeEditar || !cuantasMarcadas || !idTagDestino"
            @click="asignar()"
          >
            {{ $tc("asignarACuantas", cuantasMarcadas, { n: cuantasMarcadas }) }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import swal from "sweetalert2";
import { Select, Option, OptionGroup } from "element-ui";

/**
 * Las materias primas que hay detras de un aviso de la pantalla de etiquetas.
 *
 * Los contadores decian "58 sin etiqueta" y ahi se acababa la historia: para arreglarlo
 * habia que salir a la pantalla de materias primas, buscarlas una por una y editar cada
 * ficha. Este modal las lista y permite recolocarlas en bloque sin moverse de sitio.
 *
 * Sirve para los cinco motivos que comparten arreglo -asignar una etiqueta de materia
 * prima-: sin etiqueta, con etiqueta de proveedor, con etiqueta sin tipo, con etiqueta de
 * baja y con etiqueta inexistente. El aviso de etiquetas ocultas no entra: ahi lo que hay
 * que arreglar es el arbol, no la ficha.
 *
 * A diferencia de EtiquetaNuevaModal, este si escribe: la accion es el propio listado, y
 * separar el guardado obligaria a subir a la pantalla un estado que solo se usa aqui.
 */
export default {
  name: "MateriasPrimasRevisarModal",

  props: {
    nombreModal: { type: String, default: "modalRevisarMaterias" },
    idBusiness: { type: [String, Number], required: true },
    // Todas las etiquetas del negocio, tal como las devuelve getBusinessTags. El
    // desplegable se queda solo con las de materia prima que se pueden usar.
    etiquetas: { type: Array, default: () => [] }
  },

  data() {
    return {
      motivo: "sinEtiqueta",
      subproductos: [],
      marcadas: {},
      idTagDestino: null,
      busqueda: "",
      total: 0,
      tope: 500,
      truncado: false,
      puedeEditar: false,
      cargado: false,
      cargando: false,
      guardando: false,
      error: ""
    };
  },

  computed: {
    /**
     * Solo de materia prima y de alta: mandar una ficha a una etiqueta de baja seria
     * dejarla igual de atrapada que estaba.
     */
    etiquetasDestino() {
      return this.etiquetas
        .filter(function(t) {
          return t.tipo === "A" && !t.baja;
        })
        .sort(function(a, b) {
          return (a.ruta || "").localeCompare(b.ruta || "");
        });
    },

    destinoVisible() {
      return this.etiquetasDestino.filter(function(t) {
        return t.alcanzable;
      });
    },

    destinoOculto() {
      return this.etiquetasDestino.filter(function(t) {
        return !t.alcanzable;
      });
    },

    destinoElegidoOculto() {
      let vm = this;

      return this.destinoOculto.some(function(t) {
        return t.id === vm.idTagDestino;
      });
    },

    visibles() {
      let texto = this.normalizar(this.busqueda);

      if (!texto) {
        return this.subproductos;
      }

      let vm = this;

      return this.subproductos.filter(function(sub) {
        return vm.normalizar(sub.nombre).indexOf(texto) !== -1;
      });
    },

    cuantasMarcadas() {
      return this.idsMarcados.length;
    },

    idsMarcados() {
      let vm = this;

      // Solo las que se ven: si se marca todo, se filtra y se asigna, lo que el usuario
      // espera es que vaya lo que tiene delante, no lo que el buscador escondio.
      return this.visibles
        .filter(function(sub) {
          return !!vm.marcadas[sub.id];
        })
        .map(function(sub) {
          return sub.id;
        });
    }
  },

  methods: {
    /**
     * @param {string} motivo sinEtiqueta, etiquetaProveedor, etiquetaSinTipo,
     *                        etiquetaDeBaja o etiquetaInexistente.
     */
    abrir(motivo) {
      this.motivo = motivo || "sinEtiqueta";
      this.subproductos = [];
      this.marcadas = {};
      this.idTagDestino = null;
      this.busqueda = "";
      this.total = 0;
      this.truncado = false;
      this.puedeEditar = false;
      this.cargado = false;
      this.error = "";

      this.$modal.show(this.nombreModal);
      this.cargar();
    },

    cerrar() {
      this.$modal.hide(this.nombreModal);
    },

    mostrarError(mensaje) {
      this.error = mensaje || this.$t("errorInesperado");
    },

    cargar() {
      if (this.cargando) {
        return;
      }

      this.cargando = true;

      var config = {
        params: {
          idBusiness: this.idBusiness,
          motivo: this.motivo,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "categories/getBusinessSubproductsPorRevisar", config)
        .then(function(response) {
          vm.cargando = false;

          if (!response.data.response) {
            vm.mostrarError(response.data.message);
            return;
          }

          vm.subproductos = response.data.result.subproductos;
          vm.total = response.data.result.total;
          vm.tope = response.data.result.tope;
          vm.truncado = response.data.result.truncado;
          vm.puedeEditar = !!response.data.result.puedeEditar;
          vm.cargado = true;
        })
        .catch(function(error) {
          vm.cargando = false;
          vm.mostrarError(vm.$t("errorInesperado"));
          console.log(error);
        });
    },

    /**
     * Minusculas y sin tildes, igual que en la pantalla de etiquetas.
     */
    normalizar(texto) {
      return (texto || "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },

    // Vue 2 no ve las claves nuevas de un objeto, de ahi el $set.
    marcar(id, puesta) {
      this.$set(this.marcadas, id, !!puesta);
    },

    seleccionarTodas() {
      let vm = this;

      this.visibles.forEach(function(sub) {
        vm.$set(vm.marcadas, sub.id, true);
      });
    },

    seleccionarNinguna() {
      this.marcadas = {};
    },

    asignar() {
      if (this.guardando || !this.cuantasMarcadas || !this.idTagDestino) {
        return;
      }

      let vm = this;
      let destino = this.etiquetasDestino.find(function(t) {
        return t.id === vm.idTagDestino;
      });

      if (!destino) {
        return;
      }

      this.guardar(this.idsMarcados, destino.id);
    },

    /**
     * Dejarlas sin etiqueta es mejor que dejarles una que miente, pero no es lo que se
     * viene a hacer aqui, asi que se pregunta antes.
     */
    quitarEtiqueta() {
      if (this.guardando || !this.cuantasMarcadas) {
        return;
      }

      let vm = this;
      let ids = this.idsMarcados;

      swal({
        title: this.$t("dejarSinEtiqueta"),
        text: this.$tc("confirmarDejarSinEtiqueta", ids.length, { n: ids.length }),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-warning btn-fill",
        cancelButtonClass: "btn btn-default btn-fill",
        confirmButtonText: this.$t("confirmar"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: false
      }).then(function(res) {
        if (res.value) {
          vm.guardar(ids, 0);
        }
      });
    },

    guardar(ids, idTag) {
      this.guardando = true;
      this.error = "";

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        idTag: idTag,
        ids: ids,
        jwt: this.$store.getters.jwt
      };

      let vm = this;

      this.axios
        .post(this.$store.getters.apiUrl + "categories/setBusinessSubproductsTag", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.mostrarError(response.data.message);
            return;
          }

          vm.marcadas = {};
          vm.$emit("asignado", response.data.result.actualizados);

          // Se recarga en vez de quitar las filas a mano: si alguna no se actualizo
          // -porque ya no estaba, o no era de este negocio- el listado lo ensena.
          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.mostrarError(vm.$t("errorInesperado"));
          console.log(error);
        });
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup
  }
};
</script>

<style scoped>
/* ---------------------------------------------------------------------------
   Materias primas a revisar

   Mismo lenguaje que el alta de etiqueta y que la pantalla de sectorizacion:
   cabecera clara, cuerpo blanco, pie gris con las acciones. Lo unico distinto es
   que aqui el cuerpo es una lista larga, asi que el scroll va dentro de ella y el
   pie -donde se elige el destino- no se mueve.
   --------------------------------------------------------------------------- */
.rev-cabecera {
    padding: 16px 20px;
    background: #f7f9fb;
    border-bottom: 1px solid #e6e9ef;
}

.rev-cabecera h4 {
    margin: 0;
    font-size: 1.05em;
    font-weight: 600;
    color: #2c3e50;
}

/* Dice que hay que hacer en este modal -marcar y elegir destino-, asi que se lee.
   En #8b96a3 pasaba por subtitulo decorativo. */
.rev-cabecera p {
    margin: 5px 0 0;
    font-size: 0.86em;
    color: #4a5765;
}

.rev-cuerpo {
    padding: 16px 20px;
}

.rev-barra {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 12px;
}

.rev-buscador {
    flex: 1 1 auto;
    max-width: 320px;
    height: 34px;
    font-size: 0.88em;
}

.rev-seleccion {
    font-size: 0.82em;
    color: #8b96a3;
}

.rev-enlace {
    border: 0;
    background: none;
    padding: 0;
    font-size: 1em;
    color: #4a5765;
    text-decoration: underline;
}

.rev-enlace:hover {
    color: #009982;
}

.rev-sep {
    margin: 0 6px;
    color: #c3cbd5;
}

/* 6 filas y media a la vista: se ve que la lista sigue sin comerse la pantalla. */
.rev-lista {
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid #e6e9ef;
    border-radius: 3px;
}

.rev-fila {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f2f6;
    font-weight: 400;
    cursor: pointer;
}

.rev-fila:last-child {
    border-bottom: 0;
}

.rev-fila:hover {
    background: #f7f9fb;
}

.rev-fila.puesta {
    background: rgba(0, 153, 130, 0.07);
}

.rev-fila input {
    margin: 0;
    flex: 0 0 auto;
}

.rev-nombre {
    flex: 1 1 auto;
    font-size: 0.9em;
    color: #2c3e50;
}

.rev-actual {
    flex: 0 0 auto;
    font-size: 0.8em;
    color: #4a5765;
}

.rev-actual em {
    font-style: normal;
    color: #a13a2f;
}

.rev-actual.vacia {
    color: #b3bcc6;
    font-style: italic;
}

.rev-aviso {
    margin: 0 0 12px;
    padding: 8px 12px;
    background: rgba(214, 158, 46, 0.1);
    border: 1px solid rgba(214, 158, 46, 0.25);
    border-radius: 3px;
    font-size: 0.82em;
    color: #8a6420;
}

.rev-vacio {
    margin: 0;
    padding: 24px 0;
    text-align: center;
    font-size: 0.88em;
    color: #98a2ad;
}

.rev-error {
    margin: 12px 0 0;
    padding: 9px 12px;
    border-radius: 4px;
    background: rgba(161, 58, 47, 0.1);
    border: 1px solid rgba(161, 58, 47, 0.22);
    color: #a13a2f;
    font-size: 0.85em;
}

.rev-pie {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 20px;
    background: #f7f9fb;
    border-top: 1px solid #e6e9ef;
}

.rev-destino {
    flex: 1 1 auto;
    max-width: 380px;
    text-align: left;
}

/* Mismo criterio que en el modal de baja: es la decision del modal, no el rotulo
   de un campo, asi que va en el color del texto principal y sin versalitas. */
.rev-destino label {
    display: block;
    font-size: 0.94em;
    color: #2c3e50;
    font-weight: 500;
    margin-bottom: 8px;
}

.rev-select {
    width: 100%;
}

/* Sin caja: es la salida menos buena de las dos, y con boton propio pesaba igual
   que la accion principal. Rojo porque deja la ficha sin agrupar. */
.rev-quitar {
    margin-right: auto;
    border: 0;
    background: none;
    padding: 8px 0;
    font-size: 0.84em;
    color: #a13a2f;
    text-decoration: underline;
}

.rev-quitar:hover:not(:disabled) {
    color: #7d2d24;
}

.rev-quitar:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.rev-nota {
    margin: 6px 0 0;
    font-size: 0.78em;
    color: #8a6420;
}

.rev-botones {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1 auto;
    justify-content: flex-end;
}

.btn-verde {
    background: #009982;
    border: 1px solid #009982;
    color: #fff;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
    font-weight: 600;
}

.btn-verde:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.btn-claro {
    background: #fff;
    border: 1px solid #dde2e9;
    color: #4a5765;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
}

.btn-claro:hover:not(:disabled) {
    border-color: #009982;
    color: #009982;
}

.btn-claro:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>

<!-- Sin `scoped` a proposito: element-ui cuelga el desplegable del `body`, fuera de
     este componente, asi que un estilo con scope no lo alcanza. Va acotado por
     `popper-class`, de modo que no toca ningun otro `el-select` de la aplicacion. -->
<style>
.rev-desplegable .el-select-dropdown__item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.rev-desplegable .op-ruta {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Las que no se ven en el resto del panel, en el ambar de "ojo con esto" que ya usa
   la pantalla para el padre roto y los avisos. */
.rev-desplegable .op-ruta.oculta {
    color: #96690f;
}

/* Las materias primas que ya tiene, alineadas como la columna de la tabla: ayuda a
   distinguir la etiqueta que se usa de verdad de la que quedo vacia. */
.rev-desplegable .op-num {
    flex: 0 0 auto;
    min-width: 28px;
    text-align: right;
    font-size: 0.85em;
    font-variant-numeric: tabular-nums;
    color: #98a2ad;
}

.rev-desplegable .el-select-dropdown__item.selected .op-num,
.rev-desplegable .el-select-dropdown__item.hover .op-num {
    color: #4a5765;
}

.rev-desplegable .el-select-group__title {
    font-size: 0.72em;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 600;
    color: #8b96a3;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Etiquetas/MateriasPrimasRevisarModal.vue